import React, { useState, useRef, useEffect } from "react";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Loader from "../../../Components/UiComponents/Loader";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import CheckboxElement from "../../../Components/UiComponents/CheckboxElement";
import _ from "lodash";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { all, findFrom, get, getCustomerDetails } from "../../../Services/clientService";
import { Dialog } from "primereact/dialog";
import { update, deletecl } from "../../../Services/frameworkService";
import RadioElement from "../../../Components/UiComponents/RadioElement";
import { useProgramme } from "../../../Providers/ProgrammeContext";
import { oppByClient } from "../../../Services/opportunityService";
import { useNavigate } from "react-router-dom";
import { getCustomerFields2 } from "../../../Services/fieldsServices";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";

const Stakeholder = (props) => {
    const [loading, setLoading] = useState(false);
    const [frameworkDetails, setFrameworkDetails] = useState({});
    const [checkedForRemoval, setCheckedForRemoval] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newModule, setNewModule] = useState([]);
    const [clientDetails, setClientDetails] = useState([]);
    const [addClients, setAddClients] = useState(false);
    const [allClients, setAllClients] = useState([]);
    const [clData, setClData] = useState({});
    const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
    const [currentClientIndex, setCurrentClientIndex] = useState(0);
    const [commercialData, setCommercialData] = useState();
    const navigate = useNavigate()
    const { globalProgrammeData, setGlobalProgrammeData } = useProgramme();
    const [customerShort, setCustomerShort] = useState(null)
    const [showVideo, setShowVideo] = useState(false);
    const toastRef = useRef();

    const enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const getCustomerData = async (id) => {
        const customerData = await getCustomerDetails(id);
        if (customerData && customerData.data) {
            setCustomerShort(customerData.data.customer_short)
        }
    }
    useEffect(() => {
        if (tmpData) {
            getCustomerData(tmpData.customer)
        }
    }, [])

    useEffect(() => {
        if (props.frameworkData) {
            setFrameworkDetails(props.frameworkData)
        }
    }, [props.frameworkData])

    useEffect(() => {
        if (props.clientData) {
            setClientDetails(props.clientData)
        }
    }, [props.clientData])

    useEffect(() => {
        clientAllDetails()
    }, [])

    useEffect(() => {
        if (props.fieldData?.frameworkSectionClient) {
            let obj1 = _.find(props.fieldData?.frameworkSectionClient, { section_name: "Client" })?.display_name;
            let obj2 = _.find(props.fieldData?.frameworkSectionClient, { section_name: "Our Framework Delivery Team" })?.display_name;
            let obj3 = _.find(props.fieldData?.frameworkSectionClient, { section_name: "Overview of Framework Execution Plan" })?.display_name;
            let obj4 = _.find(props.fieldData?.frameworkSectionClient, { section_name: "Commercial Insights" })?.display_name;

            let combined = { obj1, obj2, obj3, obj4 };
            setNewModule(combined)
        }

    }, [props.fieldData?.frameworkSectionClient])

    useEffect(() => {
        if (currentIndex >= 0 && clientDetails) {
            getCurrentClientIndex(clientDetails)
            getCommercialData()
        }
    }, [currentIndex, clientDetails])

    const getCommercialData = async () => {
        try {
            setLoading(true)
            if (tmpData && clientDetails[currentIndex]?._id && tmpData.customer) {
                const res = await oppByClient(clientDetails[currentIndex]._id, tmpData.customer);
                if (res && res?.data) {
                    var internalHours = 0;
                    var internalCost = 0;
                    var externalCost = 0;
                    var totalBidCost = 0;
                    res.data.forEach(item => {
                        if (item.commercial !== undefined) {
                            internalHours += item.commercial.internal_hours_to_date ? parseFloat(item.commercial.internal_hours_to_date) : 0;
                            internalCost += parseFloat(item.commercial.internal_cost_to_date);
                            externalCost += parseFloat(item.commercial.external_cost_to_date);
                            totalBidCost += parseFloat(item.commercial.total_bid_cost_to_date);
                        }
                    });
                }
                setCommercialData({
                    "internalHours": internalHours,
                    "internalCost": internalCost,
                    "externalCost": externalCost,
                    "totalBidCost": totalBidCost,
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getCurrentClientIndex = (client_data) => {
        const currentClient = clientDetails[currentIndex];
        setCurrentClientIndex(client_data?.findIndex(unit => unit?._id === currentClient?._id))
    };

    const clientAllDetails = async () => {
        try {
            setLoading(true)
            var filterData = {};
            var associate = [];
            var clientData = await all(tmpData.customer, tmpData.branch, "client_name", 1, filterData, "Other")
            if (clientData && clientData.data) {
                var data = clientData.data.client;
                setClData(data)
                for (var i = 0; i < data.length; i++) {
                    associate.push({ 'label': data[i].client_name, 'id': data[i]._id });
                }
                setAllClients(associate)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const handleRemovalCheckboxChange = (id, isChecked) => {
        setCheckedForRemoval(prevState => ({
            ...prevState,
            [id]: isChecked
        }));
    };

    const deleteField = async () => {
        try {
            setLoading(true)
            if (Object.keys(checkedForRemoval).length > 0) {
                const selectedForRemoval = Object.keys(checkedForRemoval).filter(key => checkedForRemoval[key]);
                var data = clientDetails.filter(unit => selectedForRemoval.includes(unit._id.toString()))
                for (let d of data) {
                    var delData = await deletecl(props.frameworkId, d._id)
                    if (delData && delData.data) {
                        var clientData = await findFrom(props.frameworkId)
                        if (clientData && clientData.data) {
                            frameworkDetails.clients = []
                            for (var count = 0; count < clientData.data.length; count++) {
                                frameworkDetails.clients.push(clientData.data[count]._id);
                            }
                            setClientDetails(clientData.data)
                        }
                    }
                    setFrameworkDetails(frameworkDetails)
                    setGlobalProgrammeData(frameworkDetails)
                    toastRef.current.showToast({
                        type: "success",
                        message: props.fieldData.frameworkClientTab + ' Disassociated'
                    });
                }
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: "Atleast One " + props.fieldData.frameworkClientTab + " Should Be Selected"
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const associateStake = () => {
        setAddClients(true)
    }

    const closeProgrammDialog = () => {
        setAddClients(false);
    };

    const associateClient = async () => {
        try {
            setLoading(true)
            const selected = Object.keys(checkedCheckboxes).filter(key => checkedCheckboxes[key]);
            var total = selected.length;
            for (var i = 0; i < total; i++) {
                var client = clData.filter((cl) => cl.client_name === checkedCheckboxes[selected[i]].label);
                if (globalProgrammeData.clients.indexOf(client[0]._id) == -1) {
                    globalProgrammeData.clients.push(client[0]._id);
                }
            }
            if (selected.length > 0 && tmpData) {
                var updateData = await update(props.frameworkId, tmpData.customer, globalProgrammeData)
                if (updateData && updateData.data) {
                    var clientData = await findFrom(props.frameworkId)
                    if (clientData && clientData.data) {
                        setClientDetails(clientData.data)
                        toastRef.current.showToast({
                            type: "success",
                            message: props.fieldData.frameworkClientTab + ' Associated'
                        });
                        setAddClients(false)
                    }
                }
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: "Atleast One " + props.fieldData.frameworkClientTab + " Should Be Selected"
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const renderFooter = () => {
        if (customerShort) {
            const isJman = customerShort === process.env.REACT_APP_JMAN;
            const buttonLabel = isJman ? "Associate Client" : "Associate Stakeholder";

            return (
                <div className="cancel-footer">
                    <div className="align-center justify-end pb-0">
                        <ButtonElement type="submit" className="save-button" onClick={associateClient} label={buttonLabel} />
                    </div>
                </div>
            );
        }
    };

    const handlePrevious = () => {
        setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : clientDetails.length - 1));
    };

    const handleNext = () => {
        setCurrentIndex(prevIndex => (prevIndex < clientDetails.length - 1 ? prevIndex + 1 : 0));
    };

    const handleCheckboxChange = (id, isChecked, label) => {
        setCheckedCheckboxes(prevState => {
            const newState = { ...prevState };
            if (isChecked) {
                // If checked, add or update the checkbox state
                newState[id] = {
                    checked: true,
                    label: label
                };
            } else {
                // If unchecked, remove the checkbox state
                delete newState[id];
            }
            return newState;
        });
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />

            <div className="form-group row align-items-center mb-0">
                <div className="col-md-4 pl-0">
                    <p className='label-text'>{_.find(props.fieldData?.frameworkSectionClient, { section_name: "Clients Using This Type of Framework" })?.display_name}</p>
                </div>
                <div className="col-md-8 text-right">
                    <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                </div>
            </div>

            {
                _.find(props.fieldData?.frameworkClientTable, { table_name: "Associated Clients" })?.status &&
                <div className="box-border mt-10">
                    <div className="form-group row align-items-center mb-0">
                        <div className="col-md-6 pl-0">
                            <p className="label-text">
                                {_.find(props.fieldData?.frameworkClientTable, { table_name: "Associated Clients" })?.display_name}
                            </p>
                        </div>
                        <div className="col pr-0 d-flex justify-end">
                            <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={() => deleteField()} />
                            <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={associateStake} />
                        </div>
                    </div>
                    <div>
                        {
                            clientDetails.length > 0 && clientDetails?.map((unit, index) => (
                                <div className='new-field'>
                                    <div className="form-group row align-items-center mb-0 mt-0">
                                        <div className='col pr-0 d-flex' key={unit._id}>
                                            <CheckboxElement
                                                id={unit._id}
                                                name={unit.client_name}
                                                checked={checkedForRemoval[unit._id] || false}
                                                onChangeCheck={(e) => handleRemovalCheckboxChange(unit._id, e.target.checked)}
                                                className="mr-2"
                                            />
                                            <a className="form-label-text text-left mr-20 pointer mar-l-5" onClick={(e) => setCurrentIndex(index)}>{unit.client_name}</a>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
            {
                clientDetails.length > 0 && (
                    <>
                        <div className="form-group row align-items-center mb-0 mt-20">
                            <div className="col-md-8 pl-0 pt-17">
                                <p className="sub-label-text">
                                    {clientDetails[currentIndex]?.client_name}
                                </p>
                            </div>
                            <div className="col pr-0 d-flex justify-end">
                                <ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handlePrevious} />
                                <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleNext} />
                            </div>
                        </div>
                        {
                            Object.entries(newModule).map(([key, value]) => (
                                <div key={key} className='mt-10'>
                                    <Accordion activeIndex={0}>
                                        {
                                            <AccordionTab header={value} disabled>
                                                {
                                                    key == 'obj1' &&
                                                    <div className="new-field">
                                                        {
                                                            _.find(props.fieldData?.clientFieldsNew, { field_name: "Client Name" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{clientDetails[currentClientIndex]?.client_name}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: "Client Description" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: "Client Description" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{clientDetails[currentClientIndex]?.summary.client_desc}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: "Main Board Sponsor" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: "Main Board Sponsor" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{clientDetails[currentClientIndex]?.main_board_sponsor}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: "Relationship Owner" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: "Relationship Owner" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{clientDetails[currentClientIndex]?.relationship_owner}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsNew, { field_name: "Client Classification" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsNew, { field_name: "Client Classification" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    {clientDetails[currentClientIndex]?.client_classification.map((classify, index) => (
                                                                        <li key={index}>
                                                                            <label className="form-label text-left">{classify.label}</label>
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    {clientDetails[currentClientIndex]?.summary?.cross_sell_opportunities?.map((opp, index) => (
                                                                        <li key={index}>
                                                                            <label className="form-label text-left">{opp.label}</label>
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: "Sector" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: "Sector" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    {clientDetails[currentClientIndex]?.sector?.map((sec, index) => (
                                                                        <li key={index}>
                                                                            <label className="form-label text-left">{sec.label}</label>
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    key == 'obj2' &&
                                                    <div className="new-field">
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: "Business Unit" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: "Business Unit" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    {clientDetails[currentClientIndex]?.bid_team.business_units_involved?.map((unit, index) => (
                                                                        <li key={index}>
                                                                            <label className="form-label text-left">{unit.label}</label>
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: "Client Team List" })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: "Client Team List" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    {clientDetails[currentClientIndex]?.bid_team.client_team_list?.map((list, index) => (
                                                                        <li key={index}>
                                                                            <label className="form-label text-left">{list.label}</label>
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    key == 'obj3' &&
                                                    <div className="new-field">
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Mobilisation date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Mobilisation date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <RadioElement
                                                                        id="mobilisation_date"
                                                                        options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                        value={clientDetails[currentClientIndex]?.summary?.mobilisation_date?.radio}
                                                                        className="radio-group-class"
                                                                        disabled
                                                                    />
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.summary.mobilisation_date?.text}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Plan Start date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Plan Start date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <RadioElement
                                                                        id="plan_start_date"
                                                                        options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                        value={clientDetails[currentClientIndex]?.summary?.plan_start_date?.radio}
                                                                        className="radio-group-class"
                                                                        disabled
                                                                    />
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.summary.plan_start_date?.text}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Plan End date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Plan End date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <RadioElement
                                                                        id="plan_end_date"
                                                                        options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                        value={clientDetails[currentClientIndex]?.summary?.plan_end_date?.radio}
                                                                        className="radio-group-class"
                                                                        disabled
                                                                    />
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.summary.plan_end_date?.text}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Total Income Potential' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Total Income Potential' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <RadioElement
                                                                        id="total_income_potentiall"
                                                                        options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                        value={clientDetails[currentClientIndex]?.summary?.total_income_potentiall?.radio}
                                                                        className="radio-group-class"
                                                                        disabled
                                                                    />
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.summary.total_income_potentiall?.text}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Margin %' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Margin %' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <RadioElement
                                                                        id="margin"
                                                                        options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                        value={clientDetails[currentClientIndex]?.summary?.margin?.radio}
                                                                        className="radio-group-class"
                                                                        disabled
                                                                    />
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.summary.margin?.text}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    key == 'obj4' &&
                                                    <div className="new-field">
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: 'Internal Hours to Date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: 'Internal Hours to Date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{commercialData?.internalHours.toFixed(2)}&nbsp;{" hours"}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: 'Internal Cost to Date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: 'Internal Cost to Date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{(props.currency ? props.currency : '£ ') + ' ' + (commercialData?.internalCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.commanFields, { field_name: 'External Cost to Date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.commanFields, { field_name: 'External Cost to Date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{(props.currency ? props.currency : '£') + ' ' + (commercialData?.externalCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Total Cost to Date' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Total Cost to Date' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{(props.currency ? props.currency : '£') + ' ' + (commercialData?.totalBidCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per office' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per office' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.commercial?.potential_office}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per region' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per region' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.commercial?.potential_region}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per Sector' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Potential income per Sector' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.commercial?.potential_sector}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData?.clientFieldsSummary, { field_name: 'Our income VS Total Client Spent' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.fieldData?.clientFieldsSummary, { field_name: 'Our income VS Total Client Spent' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0 d-flex'>
                                                                    <label className="form-label text-left ml-20">{clientDetails[currentClientIndex]?.commercial?.our_income_VS_total_client_spent}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </AccordionTab>
                                        }
                                    </Accordion>
                                </div>
                            ))
                        }
                    </>
                )
            }
            <Dialog
                visible={addClients}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header={_.find(props.fieldData.frameworkSectionClient, { section_name: "Client" })?.display_name}
                modal
                position="right"
                onHide={closeProgrammDialog}
                footer={renderFooter()}
                className="width-32"
                draggable={false}
            >
                <div className='new-field'>
                    {
                        _.find(props.fieldData.frameworkFieldsClient, { field_name: "Select Client" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className='col pr-0'>
                                <label className="fs-16 fw-600 mar-b-3">
                                    {_.find(props.fieldData.frameworkFieldsClient, { field_name: "Select Client" })?.display_name}
                                </label>
                                {
                                    allClients.map((unit, index) => (
                                        <div key={unit.id} className='d-flex pt-10'>
                                            <CheckboxElement
                                                id={unit.id}
                                                name={unit.label}
                                                value={unit.label}
                                                // checked={checkedCheckboxes[unit.id]?.checked || false}
                                                checked={clientDetails.map(c => c._id).includes(unit.id)}
                                                onChangeCheck={(e) => handleCheckboxChange(unit.id, e.target.checked, unit.label)}
                                                className="mr-2"
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_PROGRAMMES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="programme_stakeholder" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default Stakeholder